/**
 * HealthService
 * Service for system health checks
 * Route: api/health
 */
import { BaseService } from '../base/BaseService';
export class HealthService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? HealthService.DEFAULT_SERVICE_PATH,
            basePath: HealthService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get basic system health status
     * Note: Health endpoints return raw objects (no ResponseData wrapper)
     * @returns Basic health information
     */
    async getSystemHealth() {
        const endpoint = this.getEndpoint('', '');
        const url = this.buildUrl(endpoint);
        // Health endpoint returns raw object, not ResponseData wrapped
        return await this.http.getRaw(url);
    }
    /**
     * Get detailed system health with environment info
     * Note: Health endpoints return raw objects (no ResponseData wrapper)
     * @returns Detailed health information
     */
    async getDetailedHealth() {
        const endpoint = this.getEndpoint('detailed', 'detailed');
        const url = this.buildUrl(endpoint);
        // Health endpoint returns raw object, not ResponseData wrapped
        return await this.http.getRaw(url);
    }
    /**
     * Simple ping/connectivity check
     * Note: Health endpoints return raw objects (no ResponseData wrapper)
     * @returns Ping response with timestamp
     */
    async ping() {
        const endpoint = this.getEndpoint('ping', 'ping');
        const url = this.buildUrl(endpoint);
        // Health endpoint returns raw object, not ResponseData wrapped
        return await this.http.getRaw(url);
    }
}
HealthService.DEFAULT_SERVICE_PATH = 'system';
HealthService.BASE_PATH = 'api/health';
//# sourceMappingURL=HealthService.js.map